import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  CreateWorkflowRequest,
  UpdateWorkflowOperationItem,
  UpdateWorkflowRequest,
  Workflow,
  WorkflowListItem,
  WorkflowOperationPrerequisite,
} from '@models/index';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class WorkflowsService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.bffUrl}/job-orchestrator/workflows`;

  getAll(): Observable<WorkflowListItem[]> {
    return this.http.get<WorkflowListItem[]>(this.baseUrl);
  }

  getOne(id: string): Observable<Workflow> {
    return this.http.get<Workflow>(`${this.baseUrl}/${id}`);
  }

  update(id: string, request: UpdateWorkflowRequest): Observable<Workflow> {
    return this.http.put<Workflow>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  add(request: CreateWorkflowRequest): Observable<Workflow> {
    return this.http.post<Workflow>(this.baseUrl, request);
  }

  updateOperations(workflowId: string, operations: UpdateWorkflowOperationItem[]): Observable<Workflow> {
    return this.http.put<Workflow>(`${this.baseUrl}/${workflowId}/operations`, operations);
  }

  updatePrerequisites(
    workflowId: string,
    workflowOperationId: string,
    prerequisites: WorkflowOperationPrerequisite[],
  ): Observable<Workflow> {
    return this.http.put<Workflow>(`${this.baseUrl}/${workflowId}/operations/${workflowOperationId}/prerequisites`, prerequisites);
  }
}
